
export function formatFlightNumber(flightnum: string): string {
    let result = '';

    for (let i = 0; i < flightnum.length; i++) {
        const char = flightnum.charAt(i);
        result += char.toUpperCase();
    }

    return result;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/flight-number.ts